import React, { useState } from "react"
import { Checkbox, FormControlLabel, FormHelperText } from "@material-ui/core"

function MultiCheckbox(props) {
  const {
    options = [],
    isChecked = [],
    onCheck = () => {},
    name = "",
    error = false,
    helperText = "",
    onUpdate = () => "",
  } = props

  let defaultOptionList = options
  const [getOptions, setOptions] = useState(defaultOptionList)

  // React.useEffect(() => {
  //   setOptions(defaultOptionList)
  // }, [options])

  const onUpdateCheck = (event, currentValue) => {
    const { checked, value } = event.target
    let updatedSelected = getOptions.map((item) => {
      return {
        ...item,
        isChecked: currentValue === item?.value ? checked : item.isChecked,
      }
    })
    setOptions([...updatedSelected])
    onCheck(updatedSelected)
  }

  return (
    <div>
      {getOptions.map((option, idx) => (
        <FormControlLabel
          key={idx}
          control={
            <Checkbox
              defaultChecked={option.isChecked}
              onChange={(e) => {
                onUpdateCheck(e, option.value)
              }}
              name={name}
              color="primary"
              inputProps={{ "aria-label": option.label }}
            />
          }
          label={option.label}
        />
      ))}
      {error === true && (
        <FormHelperText style={{ color: "#f44336" }}>
          {helperText}
        </FormHelperText>
      )}
    </div>
  )
}

export { MultiCheckbox }
export default MultiCheckbox
